import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../components/custom/Loader";
import CopyrightPreviewFormTwo from "../../../../components/preview_applications/copyright/CopyrightPreviewFormTwo";
import { useFindApplicationFormTwoQuery } from "../../../../redux/api/copyrightApplicationFormTwoApiSlice";
import ShowFilePreviewModal from "./ShowPreviewFiles";

export default function PreviewApplicationFormTwo() {
  const { profileDetailsId, profileId } = useParams();
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const navigate = useNavigate();

  const {
    data: showData,
    isLoading: isLoadingShow,
    refetch: refetchShow,
  } = useFindApplicationFormTwoQuery(profileDetailsId);

  useEffect(() => {
    refetchShow();
  }, [refetchShow, profileDetailsId]);

  const applicationFormTwo = showData?.data;

  if (isLoadingShow) {
    return <Loader />;
  }
  return (
    <div>
      <section className="section pt-3 pb-5 chuktipotro2 service-single">
        <div className="container">
          <div className="d-flex justify-content-center align-items-center">
            <div className="card w-100">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-application-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-application"
                    type="button"
                    role="tab"
                    aria-controls="nav-application"
                    aria-selected="true"
                  >
                    দ্বিতীয় অংশ
                  </button>
                </div>
              </nav>
              <div
                className="tab-content p-4 border border-top-0"
                id="nav-tabContent"
              >
                <div
                  className="tab-pane fade active show"
                  id="nav-application"
                  role="tabpanel"
                  aria-labelledby="nav-application-tab"
                >
                  <CopyrightPreviewFormTwo data={applicationFormTwo} />

                  <div className="submit-area mt-4">
                    {Number(applicationFormTwo?.form_status) !== 2 ? (
                      <div className="text-center d-flex gap-3 justify-content-center">
                        <Link
                          to={`/applicant/application-second-part-update/${profileDetailsId}`}
                          className="custombtn5"
                        >
                          পরিবর্তন করুন
                        </Link>
                      </div>
                    ) : (
                      <div className="text-center d-flex gap-3 justify-content-center">
                        <Link
                          to={`/applicant/application-payment/${profileId}`}
                          className="custombtn5"
                        >
                          পেমেন্ট
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ShowFilePreviewModal
        setPreviewModal={setPreviewModal}
        previewModal={previewModal}
        previewUrl={previewFile}
        setPreviewUrl={setPreviewFile}
      />
    </div>
  );
}
